"use client";

import Image from "next/image";
import DATA from "./data.json";
import styles from "./AppFeature.module.css";
import { useLocale } from "next-intl";

type Card = {
  ar: {
    title: string;
    description: string;
    image: string;
  };
  en: {
    title: string;
    description: string;
    image: string;
  };
};

export const AppFeature = () => {
  const locale = useLocale() as "ar" | "en";
  return (
    <div className={styles.cardContainer}>
      {DATA.map((card: Card, i) => {
        const { title, description, image } = card[locale];
        return (
          <div className={styles.card} key={i}>
            <div className={styles.imageContainer}>
              <Image 
                src={image} 
                alt={title} 
                className={styles.image}
                width={0}
                height={0}
                sizes="100%"
                style={{ width: '100%', height: 'auto' }}
              />
            </div>

            <h4 className={styles.title}>{title}</h4>
            <p className={styles.description}>{description}</p>
          </div>
        );
      })}
    </div>
  );
};
